import { colors } from 'fitify-ui/src/theme/colors'
import styled, { css } from 'styled-components'

import type { TextTypes } from './Text.Types'

export const baseTextVariants = {
  h1: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  h2: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  h3: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  h4: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  h5: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  h6: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  `,
  p: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  button: css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
  `,
}

export const TextStyles = styled.p<TextTypes.StyledProps>`
  white-space: pre-wrap;

  ${(props) =>
    props.fontFamily
      ? css`
          font-family: ${props.fontFamily};
        `
      : css`
          font-family: 'Graphik LCG Web', sans-serif;
        `}

  ${(props) =>
    props.fontWeight
      ? css`
          font-weight: ${props.fontWeight};
        `
      : css`
          font-weight: 400;
        `}

  ${(props) =>
    props.color
      ? css`
          color: ${colors[props.color]};
        `
      : css`
          color: inherit;
        `}

  ${(props) => props.$variant && props.theme.textVariants[props.$variant]};

  strong {
    font-weight: 500;
  }

  em {
    padding-right: 5px;
    padding-left: 5px;
    border-radius: 4px;
    margin-right: 0;
    background: #b8fa4e;
  }
`
